import { Button, Row } from "antd";
import { useCallback } from "react";

type FormButtonsProps = {
  isFormDisabled: boolean;
  activeTab: string;
  isNextPrimary: boolean;
  selectedUser: any;
  setErrors: React.Dispatch<React.SetStateAction<any>>;
  saveNew: (shouldReset: boolean, val: boolean) => void;
  selectExisting: (shouldReset: boolean, id: string, val: boolean) => void;
  closeSideBar: () => void;
};

export const FormButtons = ({
  isFormDisabled,
  activeTab,
  isNextPrimary,
  selectedUser,
  setErrors,
  saveNew,
  selectExisting,
  closeSideBar,
}: FormButtonsProps) => {
  const onAddClicked = useCallback(
    (shouldResetForm: boolean): void => {
      setErrors(null);

      activeTab === "1"
        ? saveNew(shouldResetForm, isNextPrimary)
        : selectExisting(shouldResetForm, selectedUser.id, isNextPrimary);
    },
    [activeTab, isNextPrimary, saveNew, selectExisting, selectedUser, setErrors]
  );

  const add = useCallback(() => onAddClicked(false), [onAddClicked]);

  const addNew = useCallback(() => onAddClicked(true), [onAddClicked]);

  return (
    <Row className="divider px-6 py-6">
      <Button
        shape="round"
        type="primary"
        className="mr-4"
        onClick={add}
        disabled={isFormDisabled}
      >
        Add
      </Button>
      <Button
        shape="round"
        className="mr-4"
        disabled={isFormDisabled}
        onClick={addNew}
      >
        Add & New
      </Button>

      <Button
        shape="round"
        className="mr-4"
        disabled={isFormDisabled}
        onClick={closeSideBar}
      >
        Cancel
      </Button>
    </Row>
  );
};
